import { Routes } from '@angular/router';

import { roleGuard } from '../../core/guards/role.guard';
import { RoleCode } from '../../shared/models/user/user.enums';

export const itemsRoutes: Routes = [
	{
		path: 'items',
		canMatch: [roleGuard],
		data: {
			allowedRoles: [RoleCode.ADMIN, RoleCode.SUPER_ADMIN, RoleCode.WAREHOUSE_PERSONNEL]
		},
		children: [
			{
				path: '',
				loadComponent: () => import('./pages/items-page/items-page.component').then(c => c.ItemsPageComponent)
			}
		]
	}
];
